/* MG reels (replaces ReelUp): muted previews in the rail + fullscreen shoppable player. */
(function () {
  if (window.__mgReels) return;
  window.__mgReels = true;
  var T = window.mgReelsI18n || { add: 'Add to cart', view: 'View product', sold: 'Sold out', added: 'Added', close: 'Close', next: 'Next', prev: 'Previous', sound: 'Sound' };
  var conn = navigator.connection;
  var lite = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- rail previews ---------- */
  var playing = [];
  function startPreview(card) {
    var v = card.querySelector('.mg-reel__video');
    if (!v) return;
    if (!v.getAttribute('src')) {
      v.addEventListener('error', function onErr() { v.removeEventListener('error', onErr); v.setAttribute('src', card.getAttribute('data-orig') || card.getAttribute('data-full')); v.play().catch(function () {}); });
      v.setAttribute('src', card.getAttribute('data-preview'));
    }
    v.muted = true;
    var p = v.play();
    if (p && p.then) p.then(function () { card.classList.add('is-playing'); }).catch(function () {});
    if (playing.indexOf(card) < 0) playing.push(card);
    while (playing.length > 3) stopPreview(playing[0]);
  }
  function stopPreview(card) {
    var v = card.querySelector('.mg-reel__video');
    if (v && !v.paused) v.pause();
    card.classList.remove('is-playing');
    var i = playing.indexOf(card);
    if (i >= 0) playing.splice(i, 1);
  }
  var io = (!lite && !reduce && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.6) startPreview(e.target);
      else stopPreview(e.target);
    });
  }, { threshold: [0, 0.6, 1] }) : null;

  function bind(root) {
    (root || document).querySelectorAll('.mg-reel:not([data-mg-bound])').forEach(function (card) {
      card.setAttribute('data-mg-bound', '1');
      if (io) io.observe(card);
      var btn = card.querySelector('.mg-reel__media');
      if (btn) btn.addEventListener('click', function () {
        var rail = card.closest('.mg-reels__rail');
        var list = rail ? Array.prototype.slice.call(rail.querySelectorAll('.mg-reel')) : [card];
        open(list, list.indexOf(card));
      });
    });
  }

  /* ---------- player ---------- */
  var ICON = {
    close: '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    on: '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8.5a5 5 0 010 7M18.5 6a8.5 8.5 0 010 12" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>',
    off: '<svg viewBox="0 0 24 24" width="20" height="20"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
  };
  var el, video, bar, addBtn, soundBtn, list = [], idx = 0, lastFocus = null, touchX = null, touchY = null;

  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'mg-player';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<div class="mg-player__stage">' +
        '<video class="mg-player__video" playsinline loop preload="auto"></video>' +
        '<div class="mg-player__loader" aria-hidden="true"><span></span></div>' +
        '<button type="button" class="mg-player__btn mg-player__close" aria-label="' + T.close + '">' + ICON.close + '</button>' +
        '<button type="button" class="mg-player__btn mg-player__sound" aria-label="' + T.sound + '">' + ICON.on + '</button>' +
        '<button type="button" class="mg-player__btn mg-player__prev" aria-label="' + T.prev + '">' + ICON.prev + '</button>' +
        '<button type="button" class="mg-player__btn mg-player__next" aria-label="' + T.next + '">' + ICON.next + '</button>' +
        '<div class="mg-player__bar" hidden></div>' +
      '</div>';
    document.body.appendChild(el);
    video = el.querySelector('.mg-player__video');
    bar = el.querySelector('.mg-player__bar');
    soundBtn = el.querySelector('.mg-player__sound');
    el.querySelector('.mg-player__close').addEventListener('click', close);
    el.querySelector('.mg-player__prev').addEventListener('click', function () { go(-1); });
    el.querySelector('.mg-player__next').addEventListener('click', function () { go(1); });
    soundBtn.addEventListener('click', function () { video.muted = !video.muted; soundBtn.innerHTML = video.muted ? ICON.off : ICON.on; });
    el.addEventListener('click', function (e) { if (e.target === el) close(); });
    video.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    video.addEventListener('ended', function () { go(1); });
    ['waiting', 'loadstart', 'stalled'].forEach(function (ev) { video.addEventListener(ev, function () { el.classList.add('is-loading'); }); });
    ['playing', 'canplay', 'error'].forEach(function (ev) { video.addEventListener(ev, function () { if (ev !== 'canplay' || !video.paused) el.classList.remove('is-loading'); }); });
    el.addEventListener('touchstart', function (e) { var t = e.touches[0]; touchX = t.clientX; touchY = t.clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var t = e.changedTouches[0], dx = t.clientX - touchX, dy = t.clientY - touchY;
      touchX = touchY = null;
      if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) go(dy < 0 ? 1 : -1);
      else if (Math.abs(dx) > 60) go((dx < 0) !== (document.documentElement.dir === 'rtl') ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(document.documentElement.dir === 'rtl' ? -1 : 1);
      else if (e.key === 'ArrowLeft') go(document.documentElement.dir === 'rtl' ? 1 : -1);
    });
  }

  function show() {
    var card = list[idx];
    if (!card) return;
    var orig = card.getAttribute('data-orig');
    video.onerror = function () { if (orig && video.getAttribute('src') !== orig) { video.src = orig; video.play().catch(function () {}); } };
    el.classList.add('is-loading');
    video.src = card.getAttribute('data-full');
    var poster = card.querySelector('.mg-reel__poster');
    if (poster) video.poster = poster.currentSrc || poster.src;
    var p = video.play();
    if (p && p.catch) p.catch(function () { video.muted = true; soundBtn.innerHTML = ICON.off; video.play().catch(function () {}); });
    var prod = card.querySelector('.mg-reel__prod');
    if (!prod) { bar.hidden = true; bar.innerHTML = ''; }
    else {
      var img = prod.querySelector('img');
      var title = prod.querySelector('.mg-reel__title');
      var price = prod.querySelector('.mg-reel__price');
      var available = card.getAttribute('data-available') === 'true' && card.getAttribute('data-variant');
      bar.innerHTML =
        (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
        '<a class="mg-player__info" href="' + card.getAttribute('data-url') + '"><b></b><span></span></a>' +
        '<button type="button" class="mg-player__add"' + (available ? '' : ' disabled') + '>' + (available ? T.add : T.sold) + '</button>';
      bar.querySelector('b').textContent = title ? title.textContent : '';
      bar.querySelector('.mg-player__info span').textContent = price ? price.textContent : '';
      addBtn = bar.querySelector('.mg-player__add');
      if (available) addBtn.addEventListener('click', function () { add(card.getAttribute('data-variant'), addBtn); });
      bar.hidden = false;
    }
    el.querySelector('.mg-player__prev').style.visibility = list.length > 1 ? '' : 'hidden';
    el.querySelector('.mg-player__next').style.visibility = list.length > 1 ? '' : 'hidden';
  }

  function open(cards, i) {
    build();
    playing.slice().forEach(stopPreview);
    list = cards; idx = Math.max(0, i);
    lastFocus = document.activeElement;
    video.muted = false; soundBtn.innerHTML = ICON.on;
    el.classList.add('is-open');
    document.body.classList.add('mg-player-open');
    show();
    el.querySelector('.mg-player__close').focus();
  }
  function close() {
    if (!el) return;
    video.pause();
    video.onerror = null;
    el.classList.remove('is-loading');
    video.removeAttribute('src'); video.load();
    el.classList.remove('is-open');
    document.body.classList.remove('mg-player-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function go(step) {
    if (list.length < 2) return;
    idx = (idx + step + list.length) % list.length;
    show();
  }

  function add(variantId, btn) {
    btn.disabled = true;
    var mini = document.querySelector('mini-cart');
    var sections = (mini && mini.getSectionsToRender) ? mini.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var url = (window.theme && theme.routes && theme.routes.cart_add_url) || (window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add' : '/cart/add');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status && state.status >= 400) { btn.textContent = state.description || T.sold; return; }
      btn.textContent = T.added;
      close();
      if (mini && mini.renderContents) mini.renderContents(state);
      else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
    }).catch(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
      .finally(function () { setTimeout(function () { btn.disabled = false; btn.textContent = T.add; }, 1500); });
  }

  function init() { bind(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
